import {PhoneValidationApiDto} from "../../api/model/rest";

export class PhoneValidationResult {

	constructor(public readonly isValid: boolean,
		public readonly numberType: string,
		public readonly internationalPhoneNumber: string,
		public readonly nationalPhoneNumber: string) {}

	public static fromJson(data: PhoneValidationApiDto): PhoneValidationResult {
		return new PhoneValidationResult(data.isValid, data.numberType, data.internationalPhoneNumber, data.nationalPhoneNumber);
	}
} 